import type { AcquisitionCatalogEntry } from '@marketing-hub/shared';
import styles from '@/pages/ProjectsPage.module.css';
import type { ScrapeJobFormState } from './scrapeJobForm';

type Props = {
  entries: AcquisitionCatalogEntry[];
  onApply: (patch: Partial<ScrapeJobFormState>) => void;
};

export function AcquisitionCatalogTiles({ entries, onApply }: Props) {
  if (!entries.length) return null;

  return (
    <div>
      <p className={styles.mutedSmall}>Broncatalogus — klik om segmentatie in te vullen:</p>
      <ul className={styles.list} style={{ display: 'grid', gap: '0.5rem', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))' }}>
        {entries.map((e) => (
          <li key={e.id}>
            <button
              type="button"
              className={styles.listItem}
              style={{ width: '100%', textAlign: 'left', cursor: 'pointer' }}
              onClick={() =>
                onApply({
                  apifyPreset: e.apify_preset,
                  apifyNiche: e.segmentation.niche ?? '',
                  apifyRegion: e.segmentation.region ?? '',
                  apifyQueries: (e.segmentation.queries ?? []).join('\n'),
                  apifyMaxItems: e.suggested_max_items,
                })
              }
            >
              <strong>{e.label}</strong>
              <div className={styles.mutedSmall}>{e.description}</div>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
